/**
 * Shared style tokens for the auth modal + its sub-components.
 * Kept inline (not a CSS module) because the modal sits OUTSIDE the
 * dashboard's MUI theme provider on the marketing landing — Chakra/MUI
 * tokens aren't reachable here, and the design is dark-glass anyway.
 */
export const T = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: 'rgba(0,0,0,0.55)',
    backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '16px',
    animation: 'fadeIn 0.2s ease',
  },
  card: {
    background: 'rgba(10,10,30,0.82)',
    backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: 24,
    boxShadow: '0 8px 64px rgba(0,0,0,0.7)',
    padding: '36px 32px',
    width: '100%', maxWidth: 420,
    position: 'relative',
    animation: 'slideUp 0.25s ease',
  },
  input: {
    width: '100%', height: 48,
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 12, color: '#fff',
    padding: '0 14px', fontSize: 14,
    outline: 'none', boxSizing: 'border-box',
    transition: 'border-color 0.2s',
  },
  label: { display: 'block', color: 'rgba(255,255,255,0.55)', fontSize: 12, marginBottom: 6 },
  oauthBtn: {
    width: '100%', height: 48, borderRadius: 12,
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.13)',
    color: '#fff', fontWeight: 500, fontSize: 14,
    cursor: 'pointer', display: 'flex', alignItems: 'center',
    justifyContent: 'center', gap: 10,
    transition: 'all 0.2s',
  },
  primaryBtn: {
    width: '100%', height: 48, borderRadius: 12,
    background: 'linear-gradient(135deg, #7C3AED, #4F46E5)',
    color: '#fff', fontWeight: 600, fontSize: 15,
    border: 'none', cursor: 'pointer',
    transition: 'opacity 0.2s, transform 0.2s',
  },
  divider: { display: 'flex', alignItems: 'center', gap: 10, margin: '6px 0' },
  dividerLine: { flex: 1, height: 1, background: 'rgba(255,255,255,0.1)' },
  dividerText: { color: 'rgba(255,255,255,0.35)', fontSize: 12, whiteSpace: 'nowrap' },
};

// Shared focus/blur handlers — every input in the auth modal swaps the
// border color on focus to the brand purple. Duplicated inline four
// times in the original file; factored out so a color change is one
// edit instead of five.
export const inputFocus = (e) => { e.target.style.borderColor = 'rgba(139,92,246,0.6)'; };
export const inputBlur  = (e) => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; };
